import { useFaqCardForm } from "@/components/shared/forms/faq-card-form";
import type { CommonColor } from "@stackje/common/config";

export function AddFaqCard(defaultType: "faq1" | "faq2", defaultColors: CommonColor) {
  const { formContent, previewContent, toggleType, shuffleColors, handleSubmit } = useFaqCardForm({
    initialData: {
      title: "",
      description: "",
      expandAll: false,
      faqs: [],
      type: defaultType,
      colors: defaultColors,
    },
    mode: "add",
  });

  return {
    formContent,
    previewContent,
    toggleType,
    shuffleColors,
    handleSubmit,
  };
}
